import React from 'react';
import { Clock, FileEdit, Map, Layout } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: <Clock className="w-8 h-8 text-white" data-id="element-1" />,
    title: 'Ahorro de Tiempo',
    description: 'No pierdas horas planificando. Tenés todo listo para aplicar directamente en el aula.',
    color: 'bg-blue-600'
  }, {
    icon: <FileEdit className="w-8 h-8 text-white" data-id="element-2" />,
    title: '100% Editable',
    description: 'Archivos en Word y PowerPoint para que puedas adaptarlos a tu propio estilo y grupo.',
    color: 'bg-amber-500'
  }, {
    icon: <Map className="w-8 h-8 text-white" data-id="element-3" />,
    title: 'Diseño Curricular',
    description: 'Contenidos alineados a los núcleos de aprendizaje prioritarios y diseño curricular argentino.',
    color: 'bg-red-600'
  }, {
    icon: <Layout className="w-8 h-8 text-white" data-id="element-4" />,
    title: 'Versatilidad Total',
    description: 'Ideal tanto para escuelas formales como para talleres independientes o centros culturales.',
    color: 'bg-purple-600'
  }];
  return <section className="py-20 bg-white" data-id="element-5">
      <div className="container mx-auto px-4" data-id="element-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-7">
          {benefits.map((benefit, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-8">
              <div className={`${benefit.color} p-4 rounded-2xl shadow-lg mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3`} data-id="element-9">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-10">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-11">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}